import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
export default function useDataOnSubmit() {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value }) {
    try {
      if (!value.appointment_type_id) return false
      let mutationResponse = await executeMutation({
        chair_id: value.resource.selected_resources?.[0],
        slot_time: value.resource.start,
        appointment_type_id: value.appointment_type_id,
      })

      if (mutationResponse.error) {
        notify(notifyError('Something went wrong'))
        return false
      } else {
        notify(notifySuccess('Template applied successfully'))
      }

      if (value?.onComplete) {
        value.onComplete()
      }
    } catch (error) {
      notify(notifyError('An error occurred while submitting'))
      return false
    }
  }
}
